// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2vHxZ","amount":"Amount_amount__1A8TG","tip":"Amount_tip__3BV31","tipHeader":"Amount_tipHeader__2FbFt","tipsWrap":"Amount_tipsWrap__3KRiA"};